export default __webpack_public_path__ + "b4c65cccfa44819194ca4df0cbeeb657.jpg";